import { ExportRecommendedActionReasonModel } from "@app/exports/exportModels";
import { CheckItem } from "@app/shared";
import { QESCheckbox } from "@app/shared/qes-standards";
import classNames from "classnames";
import { uniqueId } from "lodash";
import { Component } from "react";

interface AccuracyRecommendedActionReasonFilterProps {
  onRecommendedActionReasonChange: (recommendedActionReason: string) => void;
  onSelectAllChecked: () => void;
  onSelectAllUnchecked: () => void;
  recommendedActionReasons: ExportRecommendedActionReasonModel[];
  selectedRecommendedActionReasons: string[];
  selectAllRecommendedActionReasonChecked: boolean;
  selectAllRecommendedActionReasonIndeterminate: boolean;
}

export default class AccuracyRecommendedActionReasonFilter extends Component<AccuracyRecommendedActionReasonFilterProps> {
  public render() {
    return (
      <>
        <p className="col-12 lead mb0 font-weight-bold">Recommended Action Reasons Filter</p>
        <p className="col-12">Please select the actions to include:</p>
        {this.renderRecommendedActions()}
      </>
    );
  }

  private renderRecommendedActions() {
    const selectAllId = uniqueId("selectAll");
    const inlineStyles = {
      columnCount: 4,
    };

    return (
      <div className="col-12">
        <label className="col-2 col-form-label ptb0 text-left">Include</label>
        <div key="selectAll" className={classNames("col-xl-10 col-lg-9 mt0")}>
          <CheckItem
            id={selectAllId}
            name="Select All / Deselect All"
            checked={this.props.selectAllRecommendedActionReasonChecked}
            indeterminate={this.props.selectAllRecommendedActionReasonIndeterminate}
            onChecked={this.props.onSelectAllChecked}
            onUnchecked={this.props.onSelectAllUnchecked}
          />
        </div>
        <div className={classNames("col-xl-12 col-lg-12 mt0")} style={inlineStyles}>
          {this.props.recommendedActionReasons.map((v) => {
            const inputId = uniqueId(v.reason);

            return (
              <QESCheckbox
                containerClassName="form-check"
                className="form-check-input mt-0"
                id={inputId}
                key={v.reason}
                label={v.friendlyName}
                value={v.reason}
                checked={this.props.selectedRecommendedActionReasons.indexOf(v.reason) > -1}
                onChange={(e) => this.props.onRecommendedActionReasonChange(e.target.value)}
                testId={`accuracy-recommended-action-reason-checkbox--${v.friendlyName}`}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
